import { clearAdminSession, getConfiguredAdminPassword, setAdminUnlocked } from "@features/admin/utils/adminSession";
import { type FormEvent, useId, useState } from "react";

type AdminLoginPageProps = {
  onUnlocked: () => void;
};

export default function AdminLoginPage({ onUnlocked }: AdminLoginPageProps) {
  const passwordFieldId = useId();
  const [password, setPassword] = useState("");
  const [error, setError] = useState<string | null>(null);

  const handleSubmit = (event: FormEvent) => {
    event.preventDefault();
    const expected = getConfiguredAdminPassword();
    if (!expected) {
      setError("Admin access is not configured.");
      return;
    }
    if (password !== expected) {
      setError("Incorrect password.");
      return;
    }
    clearAdminSession();
    setAdminUnlocked(password);
    setError(null);
    onUnlocked();
  };

  return (
    <div className="min-h-screen bg-zinc-950 flex items-center justify-center p-6 text-zinc-100">
      <form
        className="w-full max-w-sm space-y-4 rounded-lg border border-zinc-800 bg-zinc-900/80 p-6"
        data-testid="admin-login-form"
        onSubmit={handleSubmit}
      >
        <h1 className="text-xl font-semibold">Event admin</h1>
        <label className="block text-sm text-zinc-300" htmlFor={passwordFieldId}>
          Password
        </label>
        <input
          id={passwordFieldId}
          type="password"
          className="w-full rounded-md border border-zinc-700 bg-zinc-950 px-3 py-2"
          data-testid="admin-password-input"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          autoComplete="current-password"
        />
        {error ? (
          <p className="text-sm text-red-400" data-testid="admin-login-error">
            {error}
          </p>
        ) : null}
        <button
          type="submit"
          className="w-full rounded-md bg-pink-600 py-2 text-sm font-medium hover:bg-pink-500"
          data-testid="admin-login-submit"
        >
          Sign in
        </button>
      </form>
    </div>
  );
}
